import {GetAuthDetailModel} from 'domain/usecases/private/authorizations';
import {makeGetAuthDetail} from 'main/factories/usecases/private/authorizations';
import {DateFormatEnum} from 'presentation/constants';
import {formatDateString} from 'presentation/utils';

export const getAuthDetail = async (
	nuControle: number,
	signal: AbortSignal,
): Promise<GetAuthDetailModel> => {
	const response = await makeGetAuthDetail(nuControle).get({signal});

	const responseFormatted: GetAuthDetailModel = {
		...response,
		dsSituacao: response.dsSituacao,
		dtAutorizacao: formatDateString(
			response.dtAutorizacao,
			DateFormatEnum.DATE_FORMAT_7,
			DateFormatEnum.DATE_FORMAT_8,
		),
		dtValidade: formatDateString(
			response.dtValidade,
			DateFormatEnum.DATE_FORMAT_7,
			DateFormatEnum.DATE_FORMAT_8,
		),
		mensagens: response.mensagens.map(message => ({
			...message,
			dtMensagem: formatDateString(
				message.dtMensagem,
				DateFormatEnum.DATE_FORMAT_7,
				DateFormatEnum.DATE_FORMAT_9,
			),
		})),
	};

	return responseFormatted;
};
